import { applyMiddleware, compose, createStore } from "redux";
import thunk from "redux-thunk";
import logger from "redux-logger";

// Middlewares
import { apiMiddleware } from "./api/http";
import { authenticationApiMiddleware } from "./api/authentication";

import { brokerMiddleware } from "./brokerHub/middleware";
import { downloadFileMiddleware } from "./downloadFile/middleware";
import { notificationsMiddleware } from "./notifications/middleware";
import { projectionsMiddleware } from "./projections/middleware";
import { resourcesMiddleware } from "./resources/middleware";
import { runCalculationMiddleware } from "./runCalculation/middleware";
import { runModuleMiddleware } from "./runModule/middleware";
import { userProfileMiddleware } from "./userProfile/middleware";

// Reducer
import rootReducer from "./rootReducer";

export function configureStore(initialState = {}) {
    const middleware = [
        thunk,

        apiMiddleware,
        authenticationApiMiddleware,

        brokerMiddleware,
        downloadFileMiddleware,
        notificationsMiddleware,
        projectionsMiddleware,
        resourcesMiddleware,
        runCalculationMiddleware,
        runModuleMiddleware,
        userProfileMiddleware,
    ];

    const enhancers = [];

    if (process.env.NODE_ENV === "development") {
        if (localStorage.getItem("redux-logger-enabled") === "true") {
            middleware.push(logger);
        }

        // Use the browser's./Userdev tools extension if installed
        if (typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__) {
            enhancers.push(window.__REDUX_DEVTOOLS_EXTENSION__());
        }
    }

    return createStore(rootReducer, initialState, compose(applyMiddleware(...middleware), ...enhancers));
}

// Get the application-wide store instance, prepopulating with state from the server where available.
const initialState = window.initialReduxState;
export const store = configureStore(initialState);
